/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".location-div[_ngcontent-%COMP%]   .map-container[_ngcontent-%COMP%]{width:800px;height:100%;padding:10px}@media (max-width:1440px){.location-div[_ngcontent-%COMP%]{height:610px;width:98%;overflow-y:scroll;overflow-x:hidden;padding-right:25px}.location-div[_ngcontent-%COMP%]   .map-container[_ngcontent-%COMP%]{width:100%;height:auto;padding:0}}"];
export { styles as styles };
